module.exports = __webpack_public_path__ + "static/media/11.a838e28f.jpg";